import config from 'js/app/config';
import path from 'js/lib/path';

import type { Domain } from 'bundles/enterprise-legacy-learner-home/types/xdpTypes';
import { getBreadcrumbsFromDomain } from 'bundles/enterprise-legacy-learner-home/utils/xdpUtils';
import { type BreadcrumbSchemaMarkup, getSchemaBreadcrumbsList } from 'bundles/seo/utils/schemaMarkupUtils';

const COURSERA_ORIGIN = config.url.base;

export const getBreadcrumbSchema = (
  domain: Domain | undefined,
  keywordId: string,
  originOverride?: string
): BreadcrumbSchemaMarkup => {
  const origin = originOverride || COURSERA_ORIGIN;
  const routes = getBreadcrumbsFromDomain(domain);

  return getSchemaBreadcrumbsList(
    routes.map((route, i) => {
      const isLastBreadcrumb = i === routes.length - 1;

      return {
        name: route.name,
        absoluteUrl: isLastBreadcrumb
          ? path.join(origin, `${route.path}#${keywordId}`)
          : path.join(origin, `${route.path}`),
      };
    })
  );
};
